import React, { useEffect, useMemo } from "react";
import { ReportTemplateType } from "../../../models/reporting/reportTemplate";
import { showApiError } from "../../framework/formUtils";
import { useAppDispatch, useAppSelector } from "../../../framework/customStore";
import {
    fetchReportTemplates,
    setCurrentReportTemplate,
    setSelectedReportTemplate,
} from "../../../store/reportTemplateSlice";
import { useAsyncThunkAction } from "../../../hooks/useAsyncThunkAction";
import { LoadingIndicator } from "../../framework/loadingIndicatorNew";
import { GroupableWorkTimeReportMain } from "./groupableWorkTimeMain";

interface Props {
    type?: ReportTemplateType;
}

export const GroupableWorkTimeWrapper = ({
    type = ReportTemplateType.WorkTimeReport,
}: Props) => {
    const dispatch = useAppDispatch();
    const reloadKey = useAppSelector((state) => state.reportTemplate.reloadKey);

    const templates = useAppSelector(
        (state) => state.reportTemplate.templates[type]
    );
    const templateId = useAppSelector(
        (state) => state.reportTemplate.selected[type]
    );
    const template = useMemo(
        () => templates?.find((t) => t.id === templateId),
        [templates, templateId]
    );
    const loading = useAppSelector((state) => state.reportTemplate.loading);

    useAsyncThunkAction(
        () => fetchReportTemplates({ type }),
        { onError: showApiError },
        [type, reloadKey]
    );

    const handleTemplateSelect = (id: string) => {
        dispatch(setSelectedReportTemplate({ id, type }));
    };

    // Select first template by default
    useEffect(() => {
        if (!templateId && templates?.length > 0) {
            handleTemplateSelect(templates[0].id);
        }
    }, [templateId, templates]);

    useEffect(() => {
        if (!!template?.json) {
            dispatch(setCurrentReportTemplate(template.json));
        }
    }, [template?.json]);

    return (
        <>
            <LoadingIndicator loading={loading} />
            {!!templates ? <GroupableWorkTimeReportMain type={type} /> : null}
        </>
    );
};
